<header class="top-navbar">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/home" (click)="closeMenu()">
        <div class="big-tagline">
          <h1>ANYSPACE inc</h1>
        </div>
      </a>

      <button class="navbar-toggler" type="button" (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen" aria-controls="navbars-host" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" [class.show]="menuOpen" id="navbars-host">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/home" (click)="closeMenu()">Home</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/about" (click)="closeMenu()">About Us</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/commercial" (click)="closeMenu()">Commercial</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/partnerships" (click)="closeMenu()">Partnerships</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/holdings" (click)="closeMenu()">Holdings</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/retail" (click)="closeMenu()">Retail</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/transportation" (click)="closeMenu()">Transportation</a></li>
          <li class="nav-item" [routerLinkActive]="['active']"><a class="nav-link" routerLink="/contact" (click)="closeMenu()">Contact</a></li>
        </ul>

        <ul class="nav navbar-nav navbar-right auth-links">
          <ng-container *ngIf="!currentUser; else signedInLinks">
            <li><a class="hover-btn-new log" routerLink="/login" (click)="closeMenu()"><span>Customer Login</span></a></li>
            <li><a class="hover-btn-new register-link" routerLink="/register" (click)="closeMenu()"><span>Create Account</span></a></li>
          </ng-container>
        </ul>

        <ng-template #signedInLinks>
          <div class="signed-in-box">
            <span class="signed-in-name">{{ currentUser?.full_name }}</span>
            <button type="button" class="hover-btn-new log" (click)="logout()">
              <span>Logout</span>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </nav>
</header>
